import { ClearCart } from '../util/PurchaseManager.js';
import * as srs from './srs.js'

export async function get_cfg(id) {
    if(id === 'pitcherstest'){
        const cfg = await get_cfg("pitchersorebro")
        cfg.text = "Pitchers test"
        cfg.sid = "S0009999"
        cfg.uid= id

        return cfg;
    }
    try {
        const req = {
            fkn: "MDB",
            uid: id
        };
        const response = await fetch("https://shop.svepos.se/mdb", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(req)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // ✅ Parse JSON response correctly
        const sdo = await response.json(); // <--- THIS WAS MISSING

        return sdo.rco

        /*
        if (sdo.ok === "000") {
            sbo.cfg = sdo.rco;
            this.validate_unit();
        } else {
            this.no_auth();
        }
        */
    } catch (error) {
        console.error("Error:", error);
    }
}


export function getMenuList() {


    var self = this;

    //alert(JSON.stringify(sbo.cdo.unit));
    //var srv = null;
    //if(sbo.cdo.unit.sid == "S0003200") srv = srs;
    //if(sbo.cdo.unit.sid == "S0003201") srv = srs01;

//    this.setState({ txt:"Laddar grupp", mga: [] });

    var prm = {};
    //prm.sid = sbo.cdo.sid;
    //prm.sid = sbo.cfg.sid;
    prm.req = "dsi.dsi_ecom.ecom_chan";
    prm.req = "dsi.dsi_mnu.mnu_list";
    //prm.mnuid = gid;
    //prm.channel = 

    //alert(JSON.stringify(prm));
    return srs.sio_req(prm)
        .then(function(ret){
            //console.log(ret.rca)

            const menu = ret.rca.map((item) => ({
                id: item.mnuid,
                name: item.text
              }));
              
            //alert(JSON.stringify(ret));
            //console.log("\n\n");
            //console.log(JSON.stringify(ret));
            //console.log(menu)

            return menu;

            var mga = ret.rca;
            //var mgo = mga[0];
            var mgo = mga.filter(row => {
                return row.gid === self.state.gid;
            })
            var ix = 0;
            //var mgo = null;
            var mgo = mga[ix];
            var keys = Object.keys(mga);
            for(var key of keys) {
                var row = mga[key];
                if(row.gid == self.state.gid) {
                    ix = key;
                    mgo = row;
                }
            }
            //var ix = mga.indexOf(mgo);
            //alert(JSON.stringify(mgo));
            //console.log(JSON.stringify(mgo));
            return mgo;

            ////self.setState({ txt: "", mga: mga, gid: mgo.gid, mgo: mgo, selix: ix }, function() {
                ////self.dsi_mp(mgo.gid);
            });
            //self.syncTb("mnaTable");
            //self.mg_open(mgo);

}

export async function getMenu(gid) {
    const prm = {
        req: "dsi.dsi_mp.mp_web",
        mnuid: gid,
        typ: "P"
    };
    return srs.sio_req(prm)
        .then(ret => {


            //console.log(ret.rca);

            return ret.rca;
        })
        .catch(error => {
            console.error("[dsi_mp] - ERROR CAUGHT:", error);
            return null;
        });
}

export async function getItemOptions(mnuid) {
    //console.log(mnuid)

    var prm = {};
    prm.req = "pos.pos_mnudata.md_list";
    prm.mnuid = mnuid;
    //alert(JSON.stringify(prm));

    return srs.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        //self.setState({ mdo: ret.rco });
        //console.log(ret.rco.T);
        return(ret.rco)
        /*
        if(typ == "E") self.syncTb("mdeTable");
        if(typ == "T") self.syncTb("mdtTable");
        if(typ == "S") self.syncTb("mdsTable");
        if(typ == "D") self.syncTb("mddTable");
        */
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
}


export async function createOrder(sbo) {
    try {
        //sbo.cart.slot = "1300";
        //sbo.cdo.msg = "";

        let prm = {
            req: "vcm.ecom.ecom_new",
            sbo
        };
        const ret = await srs.sio_req(prm); // Await API response

        if (ret.ok !== "000") {
            console.error("Something went wrong creating order.");
            return null;
        }

        ClearCart();

        // Save order ID
        sbo.cart.orderid = ret.orderid;
        let orders = {};
        try {
            orders = JSON.parse(localStorage.getItem("orderids")) || {};
        } catch (e) {
            orders = {};
        }

        const restOrder = orders[sbo.cfg.uid] || [];
        restOrder.push(ret.orderid);
        orders[sbo.cfg.uid] = restOrder;
        localStorage.setItem("orderids", JSON.stringify(orders));
        return ret.orderid



        // Prepare Swish payment request
        let swishPrm = {
            req: "vcm.swish.mcom",
            sid: sbo.cfg.sid,
            sbo,
            notanr: sbo.cart.orderid,
            topay: sbo.cart.belopp
        };

        console.log("Requesting Swish payment:", swishPrm);

        const response = await srs.sio_req(swishPrm); // Await Swish response
        console.log("Swish response:", response);

        if (response.ok === "000") {
            const token = response.token; // Use `response`, not `ret`
            const { protocol, hostname, port } = window.location;
            const portPart = port ? `:${port}` : "";

            let cburl = `${protocol}//${hostname}${portPart}/`;
            cburl += `${sbo.cfg.uid}/order/${sbo.cart.orderid}`;

            const swishUrl = `swish://paymentrequest?token=${token}&callbackurl=${encodeURIComponent(cburl)}`;

            console.log("Redirecting to Swish:", swishUrl);
            window.location.href = swishUrl;

            // Fallback in case Swish is not installed
            setTimeout(() => {
                document.location.href = cburl;
            }, 300);
        } else {
            console.error("Swish payment failed.");
            throw new Error("999 Error: Kan ej skapa Swish.");
        }
    } catch (error) {
        console.error("SWISH ERROR CAUGHT:", error);
        return null;
    }
}

export function getOrder(orderId){
    var prm = {};
    prm.req = "vcm.ecom.order_get";
    prm.orderid = orderId

    return srs.sio_req(prm)
        .catch(function(e){
            console.log(JSON.parse(e))
        });
}

export async function swishPay(orderid, total){
    try{
        const sbo = await get_cfg("pitchersorebro");

    let swishPrm = {
        req: "vcm.swish.mcom",
        sbo,
        notanr: orderid,
        topay: total*100
    };


    const response = await srs.sio_req(swishPrm); // Await Swish response

    if (response.ok === "000") {
        const token = response.token; // Use `response`, not `ret`
        const { protocol, hostname, port } = window.location;
        const portPart = port ? `:${port}` : "";

        let cburl = `${protocol}//${hostname}${portPart}/`;
        cburl += `${sbo.uid}/order/${orderid}`;

        const swishUrl = `swish://paymentrequest?token=${token}&callbackurl=${encodeURIComponent(cburl)}`;

        return{
            url: swishUrl,
            token
        }
        console.log("Redirecting to Swish:", swishUrl);
        window.location.href = swishUrl;

        // Fallback in case Swish is not installed
        setTimeout(() => {
            document.location.href = cburl;
        }, 300);
    } else {
        console.error("Swish payment failed.");
        throw new Error("999 Error: Kan ej skapa Swish.");
    }
} catch (error) {
    console.error("SWISH ERROR CAUGHT:", error);
    return null;
}
}

export async function swishQR(token){
    let prm = {
        req: "vcm.swish.qrx",
        token: token
    }
    return srs.sio_req(prm)
        .catch(function(e){
            console.warn(JSON.parse(e))
        });
}


export async function sendCode(phone){
    const body = {
        phone, 
    }

    return await srs.apiCall(body, 'auth/send-login')
}

export async function checkCode(phone, code){
    const body = {
        phone, code
    }

    return await srs.apiCall(body, 'auth/check-login')

}

export async function userOrders(phone, code){
    const body = {
        phone, code
    }

    return await srs.apiCall(body, 'user-orders')
}


export async function sendText(order, phone){
    const body = {
        order,
        phone
    }

    return await srs.apiCall(body, 'text')
}

export async function sendEmail(order, email){
    const body = {
        order, 
        email
    }

    return await srs.apiCall(body, 'email')
}

export async function getLink(order){
    const body = {
        order
    }
    
    return await srs.apiCall(body, 'gen-link')
}



